/** Matches relcore `languages` value in common/languages.ts */
export const LANGUAGE_OPTIONS: ReadonlyArray<{ code: string; name: string }> = [
  { code: 'EN', name: 'English (U.S.)' },
  { code: 'EN-GB', name: 'English (British)' },
  { code: 'ES', name: 'Spanish' },
  { code: 'FR', name: 'French' },
  { code: 'DE', name: 'German' },
  { code: 'NL', name: 'Dutch' },
  { code: 'PT', name: 'Portuguese' },
];

export function languageNameByCode(code: string): string {
  const found = LANGUAGE_OPTIONS.find((l) => l.code === code);
  return found?.name ?? code;
}
